import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSearchbar, ModalController, Platform, PopoverController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';
import { Preferences } from '@capacitor/preferences';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
declare var dynamics:any;
import { Capacitor } from '@capacitor/core';
import { PlatformService } from 'src/app/platform.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { SwiperOptions,Pagination,Navigation, Swiper } from 'swiper';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Title } from '@angular/platform-browser';
SwiperCore.use([Pagination,Navigation ]);
@Component({
  selector: 'app-chooseclient',
  templateUrl: './chooseclient.page.html',
  styleUrls: ['./chooseclient.page.scss'],
})
export class ChooseclientPage implements OnInit {
  
  environments=[]
  loadingLanguages=false
  languages=[];
  activeIndex
  choosenLanguage='';
  @ViewChild('swiper', { static: false }) swiper: SwiperComponent;
  slides: Swiper;
  config: SwiperOptions = {
    slidesPerView: 1,
    pagination:{clickable:false},
    allowSlideNext:false,
    allowSlidePrev:false
  };
  productionClients =[]
  testingClients =[]
  @ViewChild('searchInput') searchInput:IonSearchbar;
  @Input() fromModal: any;
  width=window.innerWidth;
  height=window.innerHeight;
  hide=true
  selectedProductionClient:any='';
  selectedTestingClient:any='';
  testingDomain;
  selectedEnvironment:any='';
  isNative=false;
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    public platformSRV:PlatformService,
    private platform:Platform,
    public modalController: ModalController,
    private router: Router,
    private popoverController: PopoverController,
    public dataService:DataService,
    private titleService:Title
  ) { 

    
  }
  onSlideChange(ev) {  
    this.activeIndex= this.slides.activeIndex
  }
  setSwiperInstance(swiper) {
    this.slides = swiper;
    this.activeIndex= this.slides.activeIndex
    }
    clientChanged(){
      this.testingDomain['clientName'] = this.selectedTestingClient?.clientName
      if(this.selectedTestingClient && this.selectedEnvironment){
        this.testingDomain['webUrl'] = this.selectedTestingClient?.gateway + this.selectedEnvironment?.base
      }
      
    }
    envChanged(){
      this.testingDomain['selectedEnvironment'] = this.selectedEnvironment.base
      if(this.selectedTestingClient && this.selectedEnvironment){
        this.testingDomain['webUrl'] = this.selectedTestingClient?.gateway + this.selectedEnvironment?.base
      }
     
      
    }
  
  
  
  
  back(){
    this.slides.allowSlidePrev=true
     this.slides.slideTo(this.slides.activeIndex-1)
     this.choosenLanguage='';
     this.slides.allowSlidePrev=false
  }
  async ngOnInit() {
    this.testingDomain={}
    this.testingDomain['webUrl']=''
    this.testingDomain['clientName']=''
    this.testingDomain['selectedEnvironment']=''
    if(Capacitor.isNativePlatform()){
      this.isNative=true
      if(this.dataService.isProductionBuild){
        this.dataService.getProductionClients()
        .pipe(map(data=>{
          this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
            if(value){
                data['data'].forEach(element => {
                  for (
                    var i = 0;
                    i < value.clients.length;
                    i++
                  ){
                    if(value.clients[i].webUrl=='https://'+element['webUrl']){
                    
                      element['selected']=true
                    } 
                  }
                });
                
              }
          })
          
          return data
        })
        
        )
        
        .subscribe({
          next:(response:any)=>{
            if(response?.error==0){
              response.data = response?.data.sort(this.compareClients);
              this.productionClients=response?.data
            } else {
              this.errorHandlerSRV.displayErrorMessage(response,true)
            }
          }, error:err=>{
            this.errorHandlerSRV.displayErrorMessage(err,true)
          }
         
          
        })
      } else {
        this.dataService.getTestingClients()
        .subscribe({
          next:(response:any)=>{
            if(response?.error==0){
              response.data = response?.data.sort(this.compareClients);
              this.testingClients=response?.data
              this.environments=response?.environments
            } else {
              this.errorHandlerSRV.displayErrorMessage(response,true)
            }
          }, error:err=>{
            this.errorHandlerSRV.displayErrorMessage(err,true)
          }
            
          
        })
      }
      
      
    } else {
      this.isNative=false
      var urldata=new URL(this.platform.url())
      var clientName;
      var webUrl;
     if(urldata.hostname=='localhost'){
     
      this.dataService.getTestingClientsWithProxy()
      .subscribe({
        next:(response:any)=>{
          if(response?.error==0){
            response.data = response?.data.sort(this.compareClients);
            this.testingClients=response?.data
            this.environments=response?.environments
          } else {
            this.errorHandlerSRV.displayErrorMessage(response,true)
          }
        }, error:err=>{
          this.errorHandlerSRV.displayErrorMessage(err,true)
        }
          
        
      })
     }
     else {
     
       this.dataService.apiUrl=urldata.origin
        clientName= urldata.origin
        webUrl = urldata.hostname
        this.selectedProductionClient={clientName:clientName,webUrl:webUrl}
        this.testingDomain.clientName= clientName
        this.testingDomain['webUrl'] = webUrl
        this.next()
     }
    
      
      
    }
   
  }
  compareClients( clientA, clientB ) {
    if ( clientA.clientName < clientB.clientName ){
      return -1;
    }
    if ( clientA.clientName > clientB.clientName ){
      return 1;
    }
    return 0;
  }
  async closeModal() {
    this.modalController.dismiss();
   
  }
  async next(){
    var clientName;
    this.loadingLanguages=true
    if(this.dataService.isProductionBuild){
      clientName=this.selectedProductionClient['clientName']
      this.dataService.apiUrl='https://'+this.selectedProductionClient['webUrl']
    } else {
      clientName=this.testingDomain['clientName']
      this.dataService.apiUrl='https://'+this.testingDomain['webUrl']
    }
   
    
    var languages=[]
    this.dataService.getData("api/v1/public/languages")
    .subscribe({
     next:(data:any)=>{
      if(data?.status=='success'){
        for (
          var i = 0;
          i < Object.entries(data['settings']).length;
          i++
        ){
          languages.push(data['settings'][i])
        }
        this.languages=languages
      this.loadingLanguages=false
     this.titleService.setTitle(clientName)
      this.nextSlide()
      if(this.languages.length==1){
        this.choosenLanguage= this.languages[0].code
      }
      } else {
        this.loadingLanguages=false
        this.errorHandlerSRV.displayErrorMessage(data,true)
      }
     }, error:err=>{
      this.loadingLanguages=false
      this.errorHandlerSRV.displayErrorMessage(err,true)
    }
      
    })
    
    
  }
  
  nextSlide(){
    this.slides.allowSlideNext=true
     this.slides.slideTo(this.slides.activeIndex+1)
     this.slides.allowSlideNext=false
     
   }
   changeLanguage(lang){
    this.dataService.getData('lang/' +lang ).subscribe({
      next:async response=>{
        if(response['status']=="success"){
          this.dataService.changeLanguage(lang).then(()=>{
                
            this.router.navigateByUrl('/login')
          })
        } else {
          this.errorHandlerSRV.displayErrorMessage(response,true)
        }
    },error:err=>{
      this.errorHandlerSRV.displayErrorMessage(err,true)
    }
  
  })
  }
  async continue(){
    var selectedClient
    if(this.dataService.isProductionBuild){
      selectedClient = this.selectedProductionClient
    } else {
      selectedClient = this.testingDomain
    }
    if(!this.fromModal){
      this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
        if(value){
         var newArray=value.clients
         newArray.forEach(element => {
          element['lastSelected']=false
         });
           newArray.push({ webUrl:'https://'+selectedClient['webUrl'],
          clientName:selectedClient['clientName'],lastSelected:true})
          this.dataService.storeData(environment.clientsKey,
           {
              clients:newArray
            
          }).then(async ()=>{
           
            this.dataService.apiUrl='https://'+selectedClient['webUrl']
            this.dataService.storeData("newUser",
             {
                stepOneComplete:true,
                stepTwoComplete:true
              
            }).then(()=>{
              
              this.changeLanguage(this.choosenLanguage)
             
            })
          })
        } else {
          var clients=[]
          clients.push({ webUrl:'https://'+selectedClient['webUrl'],
          clientName:selectedClient['clientName'],lastSelected:true})
         this.dataService.storeData(environment.clientsKey,
           {
              clients
            
          }).then(async ()=>{
            this.dataService.apiUrl='https://'+selectedClient['webUrl']
           this.dataService.storeData("newUser",
             {
                stepOneComplete:true,
                stepTwoComplete:true
             
            }).then(()=>{
              this.dataService.getDisclaimers()
              this.changeLanguage(this.choosenLanguage)
             
            })
          })
        }
      })
     
       
      
    } else {
      this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
        if(value){
         var newArray=value.clients
         newArray.forEach(element => {
          element['lastSelected']=false
         });
           newArray.push({ webUrl:'https://'+selectedClient['webUrl'],
          clientName:selectedClient['clientName'],lastSelected:true})
          this.dataService.storeData(environment.clientsKey,
           {
              clients:newArray           
           
          }).then(()=>{
            this.dataService.apiUrl='https://'+selectedClient['webUrl']
            this.modalController.dismiss("refresh")
            this.dataService.storeData("newUser",
             {
                stepOneComplete:true,
                stepTwoComplete:true
             
            }).then(()=>{
              this.changeLanguage(this.choosenLanguage)
             
            })
          })
        }})
    }
  }
  

}
